import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { DashboardService } from '../services/dashboard.service';
import * as DashboardActions from './dashboard.actions';

/**
 * Dashboard Effects
 * Handles side effects for dashboard actions
 */
@Injectable()
export class DashboardEffects {
  private actions$ = inject(Actions);
  private dashboardService = inject(DashboardService);

  /**
   * Load dashboard data effect
   */
  loadDashboard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DashboardActions.loadDashboard, DashboardActions.refreshDashboard),
      switchMap(() =>
        this.dashboardService.getDashboardData().pipe(
          map(data => {
            // Transform recentDocuments to add 'id' from '_id' for frontend compatibility
            const transformedData = {
              ...data,
              recentDocuments: data.recentDocuments?.map(doc => {
                const documentId = doc._id || doc.id || '';
                return {
                  ...doc,
                  _id: documentId,
                  id: documentId
                };
              }) || []
            };
            return DashboardActions.loadDashboardSuccess({ data: transformedData });
          }),
          catchError(error => {
            console.error('Error loading dashboard:', error);
            return of(DashboardActions.loadDashboardFailure({
              error: error.message || 'Failed to load dashboard data'
            }));
          })
        )
      )
    )
  );
}

